module.exports = __webpack_public_path__ + "img/Event_Date.49b7f5a8.png";